import React, { useEffect, useState } from 'react';
import {
	isPresignedS3Url,
	needsPresignedS3Url,
	resolveS3FileUrl,
} from 'models/upload/upload.controller';

type SecureS3ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	path?: string;
	fallbackSrc?: string;
};

export function SecureS3Image({
	src,
	path,
	fallbackSrc,
	alt = '',
	...props
}: SecureS3ImageProps) {
	const [resolvedSrc, setResolvedSrc] = useState<string>(
		fallbackSrc || src || '',
	);

	useEffect(() => {
		let cancelled = false;

		const resolve = async () => {
			if (isPresignedS3Url(src)) {
				if (!cancelled) setResolvedSrc(src!);
				return;
			}

			if (needsPresignedS3Url(src, path)) {
				try {
					const signed = await resolveS3FileUrl({ url: src, path });
					if (!cancelled) setResolvedSrc(signed || fallbackSrc || '');
				} catch {
					if (!cancelled) setResolvedSrc(fallbackSrc || '');
				}
				return;
			}

			if (!cancelled) setResolvedSrc(src || fallbackSrc || '');
		};

		resolve();

		return () => {
			cancelled = true;
		};
	}, [src, path, fallbackSrc]);

	if (!resolvedSrc) {
		return null;
	}

	return <img src={resolvedSrc} alt={alt} {...props} />;
}
